import React from 'react';
import { useGeneralHooks } from '../../../Hooks/hooks';
import { Gmail, Instagram as InstagramIcon, PhoneCall as PhoneCallIcon } from '../../../Assets/Icons';
import styles from './mainFooter.module.scss';

const MainFooter: React.FC = () => {
    const { t } = useGeneralHooks();

    const handlePhoneClick = (phoneNumber: string) => {
        window.open(`tel:${phoneNumber}`, '_self');
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.footerContent}>
                {/* Logo Section */}
                <div className={styles.logoSection}>
                    <div className={styles.logoRow}>
                        <img src="/favicon.png" alt="Mr. Byte Logo" className={styles.logo} />
                        <h2 className={styles.logoTitle}>Mr. Byte</h2>
                    </div>
                    <p className={styles.logoText}>
                        {t('Footer.LogoText', 'Helping businesses grow with smart digital solutions')}
                    </p>
                </div>

                {/* Divider */}
                <div className={styles.divider} />

                {/* Contact Section */}
                <div className={styles.contactSection}>
                    <h3 className={styles.contactTitle}>
                        {t('Footer.ContactTitle')}
                    </h3>

                    <div className={styles.contactItems}>
                        {/* Phone */}
                        <button
                            className={styles.contactCard}
                            onClick={() => handlePhoneClick('+374-94-173-591')}
                        >
                            <div className={styles.iconBox}>
                                <img src={PhoneCallIcon} alt="phone" className={styles.icon} />
                            </div>
                            <div className={styles.contactInfo}>
                                <span className={styles.contactLabel}>{t('Footer.PhoneTitle')}</span>
                                <span className={styles.contactValue}>+374-94-173-591</span>
                            </div>
                        </button>

                        {/* Email */}
                        <a
                            className={styles.contactCard}
                            href="mailto:mr.byte.menu@gmail.com"
                        >
                            <div className={styles.iconBox}>
                                <img src={Gmail} alt="gmail" className={styles.icon} />
                            </div>
                            <div className={styles.contactInfo}>
                                <span className={styles.contactLabel}>{t('Footer.EmailTitle')}</span>
                                <span className={styles.contactValue}>mr.byte.menu@gmail.com</span>
                            </div>
                        </a>

                        {/* Instagram */}
                        <a
                            className={styles.contactCard}
                            href="https://www.instagram.com/mr.byte_"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div className={styles.iconBox}>
                                <img src={InstagramIcon} alt="instagram" className={styles.icon} />
                            </div>
                            <div className={styles.contactInfo}>
                                <span className={styles.contactLabel}>{t('Footer.InstagramTitle')}</span>
                                <span className={styles.contactValue}>@mr.byte_</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className={styles.bottomBar}>
                <div className={styles.bottomBarInner}>
                    <p className={styles.copyright}>
                        &copy; 2024 Mr. Byte. {t('Footer.Copyright')}
                    </p>
                    <div className={styles.bottomLinks}>
                        <a href="#privacy" className={styles.bottomLink}>
                            {t('Footer.Privacy')}
                        </a>
                        <span className={styles.bottomDot}>&middot;</span>
                        <a href="#terms" className={styles.bottomLink}>
                            {t('Footer.Terms')}
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default MainFooter
